export const THESAURUS = 'THESAURUS';
export const TEXT = 'TEXT';
export const INTEGER = 'INTEGER';
export const AUTEUR_QUALITE = 'AUTEUR_QUALITE';
export const TYPE_EVENEMENT = 'TYPE_EVENEMENT';
